export default __webpack_public_path__ + "static/media/808.70bc305b.gif";